import { render, staticRenderFns } from "./deleteInstitute.vue?vue&type=template&id=1bcfef8f"
import script from "./deleteInstitute.vue?vue&type=script&lang=js"
export * from "./deleteInstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports